import { render, staticRenderFns } from "./GridTableLeaf.vue?vue&type=template&id=64fbec6d"
import script from "./GridTableLeaf.vue?vue&type=script&lang=js"
export * from "./GridTableLeaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports